import React from "react";
import Button from "../form/Button";
import CountdownTimer from "../sections/front/Apply/CountdownTimer";
import SocialShare from "../elements/SocialShare";
import { classNames } from "../../helpers/classNames";

const UpcomingApplications = ({ data = {} }) => {
  return (
    <>
      <div className="space-y-3">
        <div className="text-center text-base">Thank you for your interest! Applications aren’t open yet—please check back soon.</div>
      </div>
      <div className="flex flex-col md:flex-row justify-center mt-4 gap-2 py-8 border-b border-shades-04">
        {/* <Button
          buttonLabel={"Application"}
          buttonFunction={() => {}}
          buttonClasses="!h-12 xl:!h-14 !rounded-full !px-6 border border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white flex-shrink flex-grow"
          buttonLabelClasses="!text-base xl:!text-xl"
        />
        <Button
          buttonLabel={"Timeline"}
          buttonFunction={() => {}}
          buttonClasses="!h-12 xl:!h-14 !rounded-full !px-6 border border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white flex-shrink flex-grow"
          buttonLabelClasses="!text-base xl:!text-xl"
        />
        <Button
          buttonLabel={"Contact Us"}
          buttonFunction={() => {}}
          buttonClasses="!h-12 xl:!h-14 !rounded-full !px-6 border border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white flex-shrink flex-grow"
          buttonLabelClasses="!text-base xl:!text-xl"
        /> */}
        {/* <Button
          buttonLabel={"Share"}
          buttonIcon={"fa-solid fa-share-from-square"}
          buttonIconPosition={"left"}
          buttonFunction={() => {}}
          buttonClasses="!h-12 xl:!h-14 !rounded-full !px-6 border border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white flex-shrink flex-grow"
          buttonLabelClasses="!text-base xl:!text-xl"
        /> */}
        <div className="flex justify-center w-full [&>div]:w-full">
          <SocialShare
            data={data}
            shareUrl={`https://vpeters.org/apply`}
            buttonClass={classNames("w-54 bg-transparent border border-chestnut-rose !text-chestnut-rose mx-auto", " hover:bg-chestnut-rose hover:!text-white")}
          />
        </div>
      </div>
      <div className="space-y-8 py-8">
        <h2 className="text-xl tracking-tight font-semibold text-center text-chestnut-rose">Application opens!</h2>
        <div className="flex justify-center">
          <CountdownTimer targetDate={data?.publishDate} />
        </div>
      </div>
    </>
  );
};

export default UpcomingApplications;
